import invariant from "tiny-invariant"

export default <T>(condition: T, message?: string): NonNullable<T> => {
  invariant(condition, message)

  return condition
}
